const backend_base = 'https://api.b2b.heringberlin.com';

export const environment = {
    production: true,
    backend: backend_base,
    rest_backend: backend_base + '/rest',
    b2c_shop_german: 'https://www.heringberlin.de',
    b2c_shop_english: 'https://www.heringberlin.com',
    h_captcha_sitekey: 'de533d37-4aee-424c-9d89-ef114aa3d349'
};
